import {
  ElegibilidadeSecaoAvaliacoesConfig,
  ModalidadePeriodo,
  TipoCurso,
} from './elegibilidade-secao-avaliacoes.config.types';

const elegibilidadeSecaoAvaliacoes: ElegibilidadeSecaoAvaliacoesConfig = [
  {
    marcas: ['estacio', 'wyden'],
    modalidades: [ModalidadePeriodo.EAD, ModalidadePeriodo.FLEX],
    tipoCurso: [TipoCurso.ESPECIALIZACAO, TipoCurso.GRADUACAO, TipoCurso.GRADUACAO_TECNOLOGICA, TipoCurso.TECNICO],
  },
  {
    marcas: ['ibmec'],
    modalidades: [ModalidadePeriodo.EAD],
    tipoCurso: [TipoCurso.ESPECIALIZACAO],
  },
  {
    marcas: ['idomed'],
    modalidades: [
      ModalidadePeriodo.AO_VIVO,
      ModalidadePeriodo.EAD,
      ModalidadePeriodo.FLEX,
      ModalidadePeriodo.PRESENCIAL,
      ModalidadePeriodo.SEMI,
    ],
    tipoCurso: [TipoCurso.ESPECIALIZACAO],
  },
];

export const getElegibilidadeSecaoAvaliacoes: ElegibilidadeSecaoAvaliacoesConfig = elegibilidadeSecaoAvaliacoes;
